import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../../context";
import { Container, Modal, MuniSpinner2, ScreenHeader, SquareButton } from "../../../components";
import { Button } from "react-bootstrap";
import {
    FilePlusIcon,
} from "../../../components/Icons";

import { useActasStore } from "../../../store/actasStore";

import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { useGeneralAppStore } from "../../../store/generalAppStore";
import { renderModal } from "../../../screens/handlers";
import Proceso from "../../../screens/Actas/Acta/Proceso";
import OpcionesActaDetalle from "./OpcionesActaDetalle";
import BadgeEstados from "../../../components/BadgeEstado";
import useActas from "../../../api/actas";
import { toast } from "react-toastify";
import { toastOptions } from "../../../config/toast";
import { Tab, Tabs, Tooltip } from "@mui/material";
import BotonAnular from "../../../components/BontonAnular";
import ModalConfirm from "../ModalConfirm";
import TabInformacion from "../../../screens/Actas/ActaDetalle/Tabs/TabInformacion";
import TabImagenes from "../../../screens/Actas/ActaDetalle/Tabs/TabImagenes";
import TabVideo from "../../../screens/Actas/ActaDetalle/Tabs/TabVideo";
import TabPdf from "../../../screens/Actas/ActaDetalle/Tabs/TabPdf";
import ModalGenerarActa from "../ModalGenerarActa";
import ModalAlertas from "../ModalAlertas";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import OpcionesActaDetalle2 from "./OpcionesActaDetalle2";
import Opcion from "./OpcionesActaDetalle2/Opcion";
import HeaderActa from "./HeaderActa";
import OpcionesActaDetalle3 from "./OpcionesActaDetalle3";
import HeaderDetalle from "../../../components/HeaderDetalle";
import ModalsOpcionesActas from "..";
import TabMotivo from "../../../screens/Actas/ActaDetalle/Tabs/TabMotivo";
import useShowOpciones from "../../../hooks/useShowOpciones";

const ModalActaDetalle = ({ type }) => {
    const { handlerModal, modals } = useGeneralAppStore();
    const { actions } = useContext(UserContext);
    const {
        // actaDetalle,
        actasDetalle, setActaDetalle } = useActasStore();
    const { getActaChequear } = useActas();

    const opciones = useShowOpciones();

    const { actaDetalle, acta, archivos, alertas, coleccionActasDetalle } = useActaDetalleStore();
    const location = useLocation();
    const [tabCurrent, setTabCurrent] = useState(1);
    const prevLink = "/" + location.pathname.split("/").filter((segmento) => segmento)[0];

    useEffect(() => {
        return () => {
            setActaDetalle(null);
        }
    }, [])

    const copiarPortaPapeles = (texto) => {
        navigator.clipboard
            .writeText(texto)
            .then(() => {
                toast.success("Copiado al portapeles", toastOptions);
            })
            .catch((err) => {
                toast.success(err, toastOptions);
            });
    };

    const handleTabs = (event, newValue) => {
        setTabCurrent(newValue);
    };

    useEffect(() => {
        if (alertas?.length > 0) {
            handlerModal({ modal: true, modalName: "alertas_acta" });
        }
    }, [])

    return (

        <Modal
            show={modals.includes('acta_detalle')}
            size="xl"
            onHide={() => {
                handlerModal({ modal: false, modalName: 'acta_detalle' })
            }}
            title={() => "Detalle acta"}
        >
            <div className="d-flex gap-5">
                <div className="d-flex gap-4  w-100 align-items-center ">
                    <div className="d-flex ">
                        <div className="pe-4 me-4" style={{ borderRight: "2px solid black" }}>
                            <h3 className="m-0">{`Acta ${acta?.dependencia} - ${acta?.numero_acta}`}</h3>
                        </div>
                        <BadgeEstados estado_id={acta?.estado_id} size={'lg'} />
                    </div>
                    {/* {actions.hasPermission('acta.update.anular') && ( acta?.estado_id != 13 && acta?.estado_id != 11 && acta?.estado_id != 12)  && <Opcion
                        type="horizontal"
                        icono={<DoNotDisturbIcon width={24} height={24} strokeWidth={1.6} />}
                        label={"Anular"} modal={"modal_confirm"}
                        anular={true}

                    />} */}

                    <div className="d-flex flex-column gap-0">
                        {
                            acta?.actas_hermanas?.length > 0 &&
                            <span className="m-0 text-danger fw-bold">Hay actas duplicadas</span>

                        }
                        <div className="d-flex  gap-5">
                            {
                                acta?.actas_hermanas?.length > 0 &&
                                <>
                                    {acta?.actas_hermanas.map((acta, index) => (
                                        <Tooltip key={index} arrow title={`${acta.estado.id == 3 ? "Cargar acta" : "Copiar número acta"}`}>
                                            <div key={index} className="d-flex flex-column align-items-center justify-content-center" style={{ cursor: "pointer" }} onClick={() => {
                                                if (acta.estado.id == 3) {
                                                    handlerModal({ modal: false, modalName: "acta_detalle" });
                                                    getActaChequear(acta.id)
                                                } else {
                                                    copiarPortaPapeles(acta.numero_acta)
                                                }
                                            }}>

                                                <h5 className="m-0">{`Acta ${acta?.dependencia} - ${acta?.numero_acta}`}</h5>
                                                <BadgeEstados estado_id={acta.estado_id} size={'sm'} />
                                            </div>
                                        </Tooltip>
                                    ))}
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <>
                {acta && (
                    <>
                        <hr />
                        <div className="d-flex gap-3">
                            {
                                opciones?.map((opcion, index) => {
                                    if (opcion.label === "Constancia" && location.pathname === "/actas-tribunales") {
                                        return (
                                            <div key={index}>
                                                <Opcion icono={opcion.icono}
                                                label={opcion.label}
                                                modal={opcion.modal}
                                                type={"horizontal"}
                                                />
                                            </div>
                                        )
                                    }
                                    return null;
                                })
                            }
                        </div>
                        {
                            acta.estado_id != 15 &&
                            <>   <div className="d-flex justify-content-between">
                                {/* <HeaderActa /> */}
                                <HeaderDetalle />
                                <section >
                                    <OpcionesActaDetalle3 type={"acta_detalle"} />
                                </section>
                            </div>
                                <hr />
                            </>
                        }

                        <Tabs
                            value={tabCurrent}
                            onChange={handleTabs}
                            textColor="primary"
                            indicatorColor="primary"
                            aria-label="secondary tabs example"
                            variant="fullWidth"
                        >
                            <Tab value={1} label="Información" />
                            <Tab value={2} label="Imagenes" />
                            <Tab value={3} label="Video" />
                            <Tab value={4} label="PDF" />
                            {
                                acta?.estado_id == 9 && acta?.motivo_no_notificado &&
                                <Tab value={5} label="Motivo" />
                            }
                        </Tabs>
                        <div style={{ minHeight: "765px" }}>
                            {tabCurrent === 1 && <TabInformacion />}
                            {tabCurrent === 2 && <TabImagenes />}
                            {tabCurrent === 3 && <TabVideo />}
                            {tabCurrent === 4 && <TabPdf />}
                            {tabCurrent === 5 && <TabMotivo />}
                        </div>
                    </>
                )}
            </>



            {/* {modals.includes('alertas_acta') && <ModalAlertas modals={modals} handlerModal={handlerModal} />}

            <ModalConfirm
                titleModal={"Confirmar"}
                titleMensaje={"Anular Acta"}
                variant={"danger"}
            /> */}
        </Modal>
    );
};

export default ModalActaDetalle;
